'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/product/card/Skeleton.tsx
import { ImageWithPlaceholder } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var ProductItemSkeleton = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({ className: twMerge("group relative h-full w-full", className) }, props), { children: /* @__PURE__ */ jsxs("div", { className: "rounded-S overflow-hidden", children: [
    /* @__PURE__ */ jsx("div", { className: "relative w-full", children: /* @__PURE__ */ jsx(
      ImageWithPlaceholder,
      {
        ratio: "1x1",
        className: "aspect-1 bg-body-dark/10 w-full animate-pulse rounded-md",
        alt: ""
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-2 pt-2", children: [
      /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 w-20 animate-pulse rounded" }),
      /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 w-3/4 animate-pulse rounded" }),
      /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 w-1/2 animate-pulse rounded" })
    ] })
  ] }) }));
};
var ProductListItemSkeleton = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsxs(
    "div",
    __spreadProps(__spreadValues({
      className: twMerge("flex w-full justify-start gap-3 p-0.5 text-start", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-24 w-24 shrink-0 animate-pulse rounded-md" }),
        /* @__PURE__ */ jsxs("div", { className: "grow space-y-2", children: [
          /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 w-20 animate-pulse rounded-md" }),
          /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 animate-pulse rounded-md" }),
          /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 w-40 animate-pulse rounded-md" }),
          /* @__PURE__ */ jsx("div", { className: "bg-body-dark/10 h-4 w-20 animate-pulse rounded-md" })
        ] })
      ]
    })
  );
};

export {
  ProductItemSkeleton,
  ProductListItemSkeleton
};
//# sourceMappingURL=chunk-GQJK47PM.mjs.map